/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_StartInputs */

const en_us2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout start`)
};

const pt_br2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início do treino`)
};

const es_419_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio del entrenamiento`)
};

const pt_pt2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início do treino`)
};

const fr_fr2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début de séance`)
};

const de_de2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsbeginn`)
};

const it_it2_offline_kind_start = /** @type {(inputs: Offline_Kind_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio allenamento`)
};

/**
* | output |
* | --- |
* | "Workout start" |
*
* @param {Offline_Kind_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_start = /** @type {((inputs?: Offline_Kind_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_start(inputs)
	if (locale === "es-419") return es_419_offline_kind_start(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_start(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_start(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_start(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_start(inputs)
	return en_us2_offline_kind_start(inputs)
});
export { offline_kind_start as "offline.kind_start" }